import { PortfolioCalendar } from '@/components/portfolio-calendar/portfolio-calendar'

/**
 * `/`: the portfolio calendar, every property on one timeline (CAP-1415). It
 * replaced the dashboard; its title is in the top bar, so the page has none.
 */
export function CalendarPage() {
  return <PortfolioCalendar />
}
